import React, { useMemo } from 'react';
import {
  makeStyles,
} from '@material-ui/core';
import moment from 'moment';
import { useMediaQuery } from 'hooks';
import { projectStateType } from 'types';
import { colors, weight } from 'globalStyle';
import { calculateDifferenceBetweenDates } from 'util/calculateDifferenceBetweenDates';
import { projectTypes } from 'types/projectType';
import LoanConditions from './LoanConditions';
import EquityConditions from './EquityConditions';
import StocksConditions from './StocksConditions';
import TokensConditions from './TokensConditions';

const toLocalDate = (date) => moment(date).format('D [de] MMMM');

const useStyles = makeStyles((theme) => ({
  root: {
    '@media (max-width: 1024px)': {
      width: '100%',
      columnGap: '18px',
      flexWrap: 'nowrap',
      overflow: 'scroll',
      paddingLeft: '26px',
      paddingRight: '26px',
      paddingBottom: '30px',
    },
  },
  primaryCard: {
    width: '100%',
    minHeight: '150px',
    height: '100%',
    border: `1px solid ${colors.GRAY_10}`,
    '@media (max-width: 1024px)': {
      minWidth: '170px',
    },
  },
  primaryCardTitle: {
    fontSize: '19px',
    [theme.breakpoints.up('lg')]: {
      fontSize: '28px',
    },
  },
  secondaryCard: {
    width: '100%',
    minHeight: '156px',
    border: `1px solid ${colors.GRAY_10}`,
  },
  anchor: {
    display: 'block',
    paddingTop: '5px',
    width: 'fit-content',
    fontWeight: weight.BOLD,
    textDecoration: 'underline',
    cursor: 'pointer',
  },
  thirdCard: {
    border: `1px solid ${colors.GRAY_10}`,
    minHeight: '165px',
  },
  cardContainer: {
    padding: '10px',
  },
  smallCard: {
    width: '100%',
    '@media (min-width: 1024px)': {
      width: '23%',
    },
  },
  bigCard: {
    width: '100%',
    '@media (min-width: 1024px)': {
      width: '27%',
    },
  },
  mediumCard: {
    width: '100%',
    '@media (min-width: 1024px)': {
      width: '33%',
    },
  },
  oneThird: {
    width: '100%',
    '@media (min-width: 1024px)': {
      width: '33.33%',
    },
  },
  quarter: {
    width: '100%',
    '@media (min-width: 1024px)': {
      width: '22%',
    },
  },
  biggerCard: {
    width: '100%',
    '@media (min-width: 1024px)': {
      width: '34%',
    },
  },
  emphasis: {
    fontWeight: 'bold',
  },
  hide: {
    // display: 'none',
  },
}));

export default ({
  project,
  color,
}) => {
  const styles = useStyles();
  const isDesktop = useMediaQuery(1023);
  const resourcesGathering = useMemo(() => {
    switch (project?.status) {
      case projectStateType.OPEN:
        return calculateDifferenceBetweenDates(project?.endDate);
      case projectStateType.ADVERTISING_CAMPAIGN:
        return (
          <p style={{ textAlign: !isDesktop && 'center' }}>
            A partir del:
            <br />
            {` ${toLocalDate(project.campaignDate)}`}
          </p>
        );
      case projectStateType.WAITING_LEGAL_REP_CONFIRMATION:
        return 'Por definir';
      default:
        return 'Finalizado';
    }
  }, [project?.endDate]);

  if (project?.projectType === projectTypes.LOAN) {
    return (
      <LoanConditions
        styles={styles}
        color={color}
        resourcesGathering={resourcesGathering}
        {...project}
      />
    );
  }
  if (project?.projectType === projectTypes.EQUITY) {
    return (
      <EquityConditions
        styles={styles}
        color={color}
        resourcesGathering={resourcesGathering}
        {...project}
      />
    );
  }
  if (project?.projectType === projectTypes.STOCKS) {
    return (
      <StocksConditions
        styles={styles}
        color={color}
        resourcesGathering={resourcesGathering}
        {...project}
      />
    );
  }
  if (project?.projectType === projectTypes.TOKENS) {
    return (
      <TokensConditions
        styles={styles}
        color={color}
        resourcesGathering={resourcesGathering}
        {...project}
      />
    );
  }

  return (
    <></>
  );
};
